import gql from 'graphql-tag'
export default gql`
  mutation updateElDefaults ($value: ElDefaults) {
    updateElDefaults(value: $value) @client {
      Defaults {
        itemType
        DefaultIncludes {
          key
          weight
        }       
      }
    }
  }
`
